import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

import AdvertisingBook from './AdvertisingBook.jsx';

const BookReader = ({ books, toggleFavorite }) => {
  const { name } = useParams();
  const book = books.find(b => b.name === name);

  if (!book) {
    return <div>Book not found</div>;
  }

  return (
  <>
    <Helmet>
          <title>{book.title}</title>
          <meta name="description" content={book.description}/>
    </Helmet>
    <div className="book-reader">
      <div className="reader-controls">
        <Link to="/"><button style={{height: '60px', width: '60px', background: 'grey'}}> Назад</button></Link>
        
        <h3>{book.author}: {book.title}</h3>
               
        <button onClick={() => toggleFavorite(book.name)} style={{height: '60px', width: '60px', background: 'grey'}}>
          {book.isFavorite ? ' ❤️ ' : ' ♡ '}
        </button>
      </div>
      
      <div className="pdf-container">
        <iframe 
          title={book.title}
          src={book.url}
          width="100%"
          height="600px"
        >
          This browser does not support PDFs. Please download the PDF to view it.
        </iframe>
      </div>
      <div className="advertising-book">
        <AdvertisingBook/>
      </div>
    </div>
    
  </>
  );
};

export default BookReader;